const CURSIVE_FONT_FAMILY = 'Great Vibes';

let fontLoadPromise = null;

function loadCursiveFont() {
  if (!fontLoadPromise) {
    fontLoadPromise = (async () => {
      if (!document.querySelector('link[data-cursive-signature-font]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap';
        link.setAttribute('data-cursive-signature-font', 'true');
        document.head.appendChild(link);
      }
      await document.fonts.load(`48px "${CURSIVE_FONT_FAMILY}"`);
      await document.fonts.ready;
    })();
  }
  return fontLoadPromise;
}

export function formatEmployeeDisplayName(person) {
  if (!person) return '';
  return [person.first_name, person.last_name].filter(Boolean).join(' ').trim();
}

export async function renderCursiveSignatureDataUrl(name) {
  const text = String(name || '').trim();
  if (!text) return null;

  await loadCursiveFont();

  const width = 480;
  const height = 140;
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, width, height);
  ctx.fillStyle = '#111111';

  let fontSize = 56;
  ctx.textBaseline = 'middle';
  do {
    ctx.font = `${fontSize}px "${CURSIVE_FONT_FAMILY}", cursive`;
    fontSize -= 2;
  } while (fontSize > 28 && ctx.measureText(text).width > width - 40);

  ctx.fillText(text, 20, height / 2);
  return canvas.toDataURL('image/png');
}
